export default "__VITE_ASSET__DtqQNv0___"